import {
  Building,
  TriangleAlert,
  CircleDashed,
  CircleCheck,
  ClockAlert,
  TrafficCone,
  ShieldOff,
} from "lucide-react";

export const iconMap: any = {
  active: (
    <div className="p-3 rounded-xl bg-primary-100">
      <Building className="w-5 h-5 text-amber-500" />
    </div>
  ),
  risk: (
    <div className="p-3 rounded-xl bg-red-200">
      <TriangleAlert className="w-5 h-5 text-red-500" />
    </div>
  ),
  approval: (
    <div className="p-3 rounded-xl bg-yellow-100">
      <CircleDashed className="w-5 h-5 text-amber-500" />
    </div>
  ),
  completion: (
    <div className="p-3 rounded-xl bg-green-100">
      <CircleCheck className="w-5 h-5 text-green-500" />
    </div>
  ),
  overall: (
    <div className="p-3 rounded-xl bg-green-100">
      <CircleCheck className="w-5 h-5 text-green-500" />
    </div>
  ),
  total: (
    <div className="p-3 rounded-xl bg-red-50">
      <Building className="w-5 h-5 text-amber-500" />
    </div>
  ),
  delayed: (
    <div className="p-3 rounded-xl bg-red-200">
      <ClockAlert className="w-5 h-5 text-red-500" />
    </div>
  ),
  blocked: (
    <div className="p-3 rounded-xl bg-red-200">
      <TrafficCone className="w-5 h-5 text-red-500" />
    </div>
  ),
  quality: (
    <div className="p-3 rounded-xl bg-red-200">
      <ShieldOff className="w-5 h-5 text-red-500" />
    </div>
  )
};
